import React from "react";
import { useTheme } from "@mui/material";
import { Stack } from "@mui/material";
import Box from "@mui/material/Box";
import MuCard, { CardProps as MuCardProps } from "@mui/material/Card";
import CardContent from "@mui/material/CardContent";
import Typography from "@mui/material/Typography";

export type CardProps = MuCardProps & {
  disabled?: boolean;
  cardimage?: React.ReactNode;
  cardtitle?: string;
  cardicon?: React.ReactNode;
  cardselected?: boolean;
};

const TrackingCard = ({ ...others }: CardProps) => {
  const theme = useTheme();
  return (
    <MuCard
      variant="outlined"
      sx={{
        width: "258px",
        height: "100px",
        borderRadius: "12px",
        display: "flex",
        flexDirection: "column",
        backgroundColor: others?.cardselected ? theme.palette.primary.lighter : "inherit",
        borderColor: others?.cardselected
          ? theme.palette.primary.dark
          : theme.palette.primary.light,
        cursor: others.disabled ? "default" : "pointer",
      }}
      {...others}>
      <CardContent
        sx={{
          flex: "1",
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
          height: "100%",
          padding: "0px",
          ":last-child": {
            paddingBottom: "0px",
          },
        }}>
        {others?.cardimage ? (
          <Stack direction="column" alignItems="center">
            {others.cardimage}
            {others.cardtitle && (
              <Typography
                sx={{
                  fontSize: "16px",
                  fontWeight: 600,
                  mt: 0.5,
                }}
                color={theme.palette.text.secondary}>
                {others.cardtitle}
              </Typography>
            )}
          </Stack>
        ) : (
          <Box
            sx={{
              display: "flex",
              alignItems: "center",
              gap: "8px",
            }}>
            {others.cardicon}
            <Typography
              sx={{
                fontSize: "20px",
                fontWeight: 600,
                lineHeight: "22px",
              }}
              color="text.primary">
              {others.cardtitle}
            </Typography>
          </Box>
        )}
      </CardContent>
      {others?.cardselected && (
        <div
          style={{
            height: "5px",
            backgroundColor: theme.palette.primary.main,
            width: "100%",
          }}></div>
      )}
    </MuCard>
  );
};

export default TrackingCard;
